// Shared "does this address carry any populated part" check, reused by the
// snapshot hydration and the From/To toggle defaults so the two can't drift.
// `street2` is optional so callers whose address shape omits it still type-check.
export function hasAnyAddressPart(address: {
    street?: string | null;
    street2?: string | null;
    city?: string | null;
    state?: string | null;
    postalCode?: string | null;
    country?: string | null;
}): boolean {
    return [
        address.street,
        address.street2,
        address.city,
        address.state,
        address.postalCode,
        address.country,
    ].some((part) => Boolean(part));
}
